<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">{{mode + ' User Account'}}</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="USERNAME:"
              label-for="username">
              <b-form-input
                id="username"
                type="text"
                v-model="userAccount.USER_NAME"
                required
                :disabled="mode === 'Edit'">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="FULL NAME:"
              label-for="fullName">
              <b-form-input
                id="fullName"
                type="text"
                v-model="userAccount.FULL_NAME"
                required>
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group
          v-show="mode === 'Add'"
          label="PARTNER API KEY:"
          label-for="apiKey">
          <b-form-input
            id="apiKey"
            class="w-50 d-inline"
            type="text"
            v-model="userAccount.PARTNER_API_KEY"
            disabled>
          </b-form-input>
          <b-btn class="ml-2" variant="secondary" size="sm" @click="generateApiKey" :disabled="!userAccount.USER_NAME"><i class="fa fa-link"></i> Generate API Key</b-btn>
        </b-form-group>
        <b-form-group
          label="STATUS:"
          label-for="status">
          <c-switch
            color="success"
            variant="pill"
            size="lg"
            v-model="userAccount.STATUS" />
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">{{mode === 'Add' ? 'Add' : 'Update'}}</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import Multiselect from 'vue-multiselect'
import server from '@/services/server'
import moment from 'moment'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'partner-accounts-modal',
  props: {
    mode: String,
    model: Object
  },
  data () {
    return {
      userAccount: {
        USER_NAME: '',
        FULL_NAME: '',
        PARTNER_API_KEY: '',
        USER_SERVICE_CODE: [],
        USER_ROLE_CODE: '',
        AVAILABILITY_START_DATE: moment().format('YYYY-MM-DD'),
        AVAILABILITY_END_DATE: moment().add(2, 'y').format('YYYY-MM-DD'),
        STATUS: false
      },
      isFetching: false,
      selectedServices: [],
      selectedRole: {}
    }
  },
  components: {
    cSwitch,
    Multiselect
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      let payload = [{
        userName: this.userAccount.USER_NAME,
        fullName: this.userAccount.FULL_NAME,
        partnerApiKey: this.userAccount.PARTNER_API_KEY,
        userServiceCode: [],
        userRoleCode: this.userAccount.USER_ROLE_CODE.CODE
      }]
      if (this.mode === 'Add') {
        payload[0].availabilityStartDate = moment().format('YYYY-MM-DD'),
        payload[0].availabilityEndDate = moment().add(2, 'y').format('YYYY-MM-DD')
      } else {
        payload[0].uaCode = this.userAccount.CODE
        payload[0].availabilityStartDate = this.userAccount.AVAILABILITY_START_DATE
        payload[0].availabilityEndDate = this.userAccount.AVAILABILITY_END_DATE
        payload[0].status = this.userAccount.STATUS ? 1 : 0
      }

      if (this.mode === 'Add') {
        this.isFetching = true
        this.$store.dispatch('userAccount/addPartner', payload).then(
          resp => this.$emit('close')
        )
      } else {
        this.$store.dispatch('userAccount/updatePartner', payload).then(
          resp => this.$emit('close')
        )
      }
    },
    getUserServices () {
      if (this.mode === 'Edit') {
        this.userAccount.USER_SERVICE_CODE = this.userServices.filter(userService => this.userAccount.USER_SERVICE_CODE.includes(userService.CODE))
      }
    },
    getUserRoles () {
      if (this.mode === 'Edit') {
        this.userAccount.USER_ROLE_CODE = this.userRoles.find(role => role.CODE === this.userAccount.USER_ROLE_CODE)
      }
    },
    generateApiKey () {
      let payload = [{ userName: this.userAccount.USER_NAME}]
      server.post('/generatePartnerApiKey', payload).then( resp => {
        let apiKey = resp.data.msgContent.partnerApiKey
        this.userAccount.PARTNER_API_KEY = apiKey
      })
    }
  },
  mounted () {
    if (this.mode === 'Edit') {
      this.userAccount = {...this.model}
      let profile = this.getByUACode(this.model.CODE)
      this.userAccount.FULL_NAME = `${profile.FIRST_NAME} ${profile.LAST_NAME}`
      this.userAccount.STATUS = this.userAccount.STATUS > 0 ? true : false
    }
    this.getUserServices()
    this.getUserRoles()
  },
  computed: {
    getStatus () {
      if (this.userAccount) {
        return this.userAccount.STATUS ? true : false
      } else {
        return false
      }
    },
    ...mapGetters('userProfile', [
      'getByUACode',
    ]),
    ...mapState('userService', {
      userServices: state => state.items
    }),
    ...mapState('userRole', {
      userRoles: state => state.items
    })

  }
}
</script>
